<template>
  <div class="general-filter-content">
    <p v-if="label" v-html="label" />

    <div class="filter-inner">
      <slot />
    </div>

    <div v-if="hasError" class="text-xs text-red-500 dark:text-red-400 mt-1"><i>{{ errorText }}</i></div>

    <div v-if="help" class="text-xs text-gray-500 dark:text-gray-400 mt-1">{{ help }}</div>
  </div>
</template>

<script>
  /* eslint-disable */
  import { computed } from 'vue'

  export default {
    name: 'Field',

    props: {
      label: String,
      help: String,
      hasError: Array
    },

    setup (props, { slots }) {
      const wrapperClass = computed(() => {
        const base = []
        const slotsLength = slots.default().length

        if (slotsLength > 1) {
          base.push('grid grid-cols-1 gap-3')
        }

        if (slotsLength === 2) {
          base.push('md:grid-cols-2')
        }

        return base
      })
      const errorText = computed(() => {
        const text = [].concat.apply([], props.hasError).join(',')
        return text
      })

      return {
        wrapperClass,
        errorText
      }
    }
  }
</script>

<style lang="scss">
  .general-filter-content {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: end;
    gap: 4px;


    p {
      width: 100%;
      font-size: 14px;
      line-height: 20px;
      font-weight: 600;
    }

    .filter-inner {
      width: 100%;
      height: auto;

      .btn-univ {
        width: 100% !important;
        height: 42px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        padding: 0 20px !important;
        box-shadow: none !important;

        @media (min-width: 480px) {
          width: max-content !important;
        }
      }
    }
  }
</style>
